module.exports = __webpack_public_path__ + "img/icon_map_nzz.dd529b4a.png";